var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7458 0H14.6807C6.80848 0 0.426758 6.38171 0.426758 14.2539V14.319C0.426758 22.1912 6.80848 28.5729 14.6807 28.5729H14.7458C22.618 28.5729 28.9997 22.1912 28.9997 14.319V14.2539C28.9997 6.38171 22.618 0 14.7458 0Z",
    fill: "#007EBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24083 9.49666C6.86443 9.14729 6.67725 8.71484 6.67725 8.2003C6.67725 7.68576 6.86543 7.23429 7.24083 6.88392C7.61722 6.53456 8.10173 6.35938 8.69535 6.35938C9.28898 6.35938 9.75447 6.53456 10.1299 6.88392C10.5063 7.23329 10.6934 7.67275 10.6934 8.2003C10.6934 8.72785 10.5053 9.14729 10.1299 9.49666C9.75347 9.84603 9.27596 10.0212 8.69535 10.0212C8.11474 10.0212 7.61722 9.84603 7.24083 9.49666ZM10.3771 11.5008V22.212H6.99257V11.5008H10.3771Z",
    fill: "#FEFFFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6437 12.5587C22.3815 13.3595 22.7498 14.4587 22.7498 15.8581V22.0226H19.5355V16.2926C19.5355 15.5869 19.3523 15.0383 18.9869 14.6479C18.6215 14.2575 18.129 14.0613 17.5124 14.0613C16.8957 14.0613 16.4032 14.2565 16.0378 14.6479C15.6724 15.0383 15.4892 15.5869 15.4892 16.2926V22.0226H12.2559V11.4705H15.4892V12.87C15.8166 12.4035 16.2581 12.0351 16.8126 11.7638C17.3672 11.4926 17.9909 11.3574 18.6846 11.3574C19.9199 11.3574 20.9069 11.7578 21.6437 12.5587Z",
    fill: "#FEFFFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.01e75ccbc465fa09d75734706f9f664a.svg";
export { ForwardRef as ReactComponent };